import { render, staticRenderFns } from "./NextReleases.vue?vue&type=template&id=1ff9a07e&"
import script from "./NextReleases.vue?vue&type=script&lang=js&"
export * from "./NextReleases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports